export default __webpack_public_path__ + "static/media/piazzajpg.eb203734.jpg";